import { useState, useEffect } from 'react';
import {
  isSafari as isSafariFunc,
  isWebKitIOS,
} from '../utils/constants/isSafari';

const useIsSafari = () => {
  const [isSafari, setIsSafari] = useState(false);
  const [isWebKit, setIsWebKit] = useState(false);
  useEffect(() => {
    setIsSafari(isSafariFunc());
    setIsWebKit(isWebKitIOS());
  }, []);
  return {
    isWebKit,
    isSafari,
  };
};

export default useIsSafari;
